import type { UserData } from './types/UserData';

/**
 * A SESSÃO JÁ PODE CHAMAR AS ROTAS COMUNS? (22/10/2026, achado D16 da auditoria.) Enquanto a troca de senha obrigatória
 * ou o aceite dos termos estiver pendente, o servidor recusa tudo com 403 (`authenticate`) — e quem pergunta sozinho, sem
 * clique (o sino, a contagem do aplicativo de computador, o push), só gera recusa: 318 em poucos minutos na conta do
 * revisor, em 22/10. Quem consulta em segundo plano pergunta aqui antes.
 */
export function sessaoLiberada(user: UserData | null | undefined): boolean {
  return !!user && !user.trocaDeSenhaObrigatoria && !user.termosPendentes;
}
